import { defineComponent, ref } from 'vue';
import AnnouncementTableComponent from '@/components/announcementTable/AnnouncementTable.vue';
import AnnouncementFormComponent from '@/components/announcementForm/AnnouncementForm.vue';

export default defineComponent({
  name: 'AnnouncementPage',
  components: {
    AnnouncementTableComponent,
    AnnouncementFormComponent
  },
  setup: () => {
    const announcementForm = ref<InstanceType<typeof AnnouncementFormComponent>>();

    const createClick = () => {
      announcementForm.value?.show();
    };

    return {
      announcementForm,
      createClick,
    };
  },
});
